
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    height: {
      type: Number,
      default: 100,
    },
  },
})
